import { useState } from "react";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import { validatePassword } from "../../api/password.api";
import { useAuth } from "../../auth/auth-context";
import { ROUTES } from "../../routes";
import "./password.view.css";

function getErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    return (
      (error.response?.data as { message?: string } | undefined)?.message ??
      "Incorrect password."
    );
  }
  return "Incorrect password.";
}

export function PasswordView() {
  const { isAuthenticated, authenticate } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isValidating, setIsValidating] = useState<boolean>(false);

  if (isAuthenticated) {
    return <Navigate to={ROUTES.driverRegistration} replace />;
  }

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
    if (error) {
      setError("");
    }
  };

  const handlePasswordSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsValidating(true);
    setError("");
    validatePassword(password)
      .then(() => {
        authenticate(password);
        navigate(ROUTES.driverRegistration, { replace: true });
      })
      .catch((error) => {
        setError(getErrorMessage(error));
      })
      .finally(() => {
        setIsValidating(false);
      });
  };

  return (
    <div className="password-page">
      <form className="password-form" onSubmit={handlePasswordSubmit}>
        <h1>Driver Registration</h1>
        <p>Enter the password to continue.</p>
        <input
          type="password"
          value={password}
          onChange={handlePasswordChange}
          placeholder="Password"
          autoFocus
          disabled={isValidating}
        />
        {error && <p className="password-error">{error}</p>}
        <button type="submit" disabled={isValidating}>
          {isValidating ? "Checking…" : "Continue"}
        </button>
      </form>
    </div>
  );
}
